<template>
  <div class="card text-center">
    <div
      class="card-header d-flex"
      :style="{
        backgroundColor: isPending ? '#ffc107' : 'black',
        padding: '10px',
        color: 'white',
      }"
    >
      <h5 class="flex-grow-1">New!</h5>
      <button
        v-if="!isPending && !isApprover"
        class="float-right btn btn-info editNewSection"
        data-bs-toggle="modal"
        data-bs-target="#editNewSection"
      >
        <i class="fa fa-pencil text-white"></i>
      </button>
      <span v-if="isPending" class="float-right btn bg-secondary"
        ><i class="fa fa-lock text-white"></i
      ></span>
    </div>
    <div class="card-body">
      <!-- <label class="form-label speedee-bold float-left">Title</label>
      <input
        type="text"
        class="form-control mb-4 p-3"
        v-model="product_header.name"
      /> -->
      <div
        style="
          border: dashed 1px black;
          padding: 20px;
          display: flex;
          flex-direction: row;
          gap: 20px;
        "
      >
        <div v-for="(products, index_pb) in product_banners" :key="index_pb">
          <img
            :src="products.image_url"
            style="
              width: 200px;
              height: 150px;
              object-fit: contain;
              border-radius: 10px;
              border: solid 1px gray;
            "
          />
        </div>
      </div>
      <div class="float-right">
        <button @click="preview()" class="btn bg-light-dark text-dark m-2">
          Preview
        </button>
        <button
          v-if="!isApprover && !isPending"
          @click="saveProductBanner(0)"
          class="btn bg-light-dark text-dark m-2"
        >
          Save Draft
        </button>
        <button
          v-if="!isApprover && !isPending"
          @click="saveProductBanner(1)"
          class="btn btn-warning text-dark m-2"
        >
          Submit For Approval
        </button>
        <button
          v-if="isApprover && isPending"
          data-bs-toggle="modal"
          data-bs-target="#approveModal"
          class="btn btn-warning text-dark m-2 approveModal"
          @click="openProductApproval(index_pb, 'newSection')"
        >
          Approval
        </button>
      </div>
    </div>
  </div>

  <!-- modal component -->
  <div>
    <Modal
      :modalTitle="'Edit New'"
      :modalSize="'modal-lg'"
      :id="'editNewSection'"
    >
      <div class="card text-dark">
        <div class="card-body">
          <div class="default-according style-1" id="accordionoc2">
            <div
              v-for="(products, index_pb2) in product_banners"
              :key="index_pb2"
              class="w-full d-flex gap-2 py-2"
            >
              <div class="card w-100">
                <div class="card-header bg-light-dark text-dark">
                  <h5 class="mb-0">
                    <button
                      class="btn bg-light-dark text-dark w-100"
                      :class="{ collapsed: !products.products_expanded }"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#collapseicon' + index_pb2"
                      aria-expanded="true"
                      :aria-controls="`collapseicon${index_pb2}`"
                    >
                      Slide
                      <span>{{ index_pb2 + 1 }}</span>
                    </button>
                  </h5>
                </div>
                <div
                  :class="['collapse', { show: products.products_expanded }]"
                  :id="`collapseicon${index_pb2}`"
                  :aria-labelledby="`collapseicon${index_pb2}`"
                  data-bs-parent="#accordionoc2"
                >
                  <div class="card-body">
                    <div style="display: flex; flex-direction: column">
                      <label class="form-label speedee-bold float-left"
                        >Image</label
                      >
                      <div
                        style="
                          display: flex;
                          flex-direction: row;
                          align-items: center;
                        "
                      >
                        <img
                          :src="products.image_url"
                          style="
                            width: 120px;
                            height: 120px;
                            object-fit: contain;
                            border-radius: 10px;
                            border: dashed 1px gray;
                          "
                        />
                        <div class="fileUpload bg-none text-left align-middle">
                          <div>
                            <span class="media-text p-2"
                              >Select from Media Library (Max dimension 1200 x
                              800 px)</span
                            >
                          </div>
                          <button
                            @click="
                              openGalleryPBModal(index_pb2, 'editNewSection')
                            "
                            aria-hidden="true"
                            class="mx-2 p-2 border w-auto"
                          >
                            Browse
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="py-2 d-flex flex-column">
                      <label class="speedee-bold float-left">Title</label>
                      <v-select
                        v-model="products.entity_name"
                        :options="titleMenuOptions"
                        label="name"
                        searchable
                        class="f-16"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <button
                  class="btn bg-light-dark text-dark"
                  @click="removeSlide(index_pb2)"
                >
                  X
                </button>
              </div>
            </div>
            <button
              class="btn bg-light-dark text-dark text-center newSlideBtn"
              @click="addNewSlide"
            >
              +
            </button>
          </div>

          <button
            type="button"
            class="btn bg-light-dark text-dark mt-4 float-right mx-2"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            id="NewSaveModalBtn"
            class="btn btn-warning text-dark mt-4 float-right"
            data-bs-dismiss="modal"
          >
            Done
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/ModalComponent.vue";
import { getRequest, postRequest } from "@/services/RequestService";
import Dropdown from "primevue/dropdown";

export default {
  props: {
    product_banners: {
      type: Array, // Adjust the prop type based on your data structure
      required: true,
    },
    isApprover: {
      type: Boolean, // Adjust the prop type based on your data structure
      required: true,
    },
    isPending: {
      type: Boolean, // Adjust the prop type based on your data structure
      required: true,
    },
  },
  components: {
    Modal,
    Dropdown,
  },

  data() {
    return {
      categories: [],
      isModalVisible: false,
      titleMenuOptions: [],
      filteredEntities: [],
      removedBannerIds: [],
    };
  },

  mounted() {
    // Pre-fill titleOptions for each banner
    this.titleDropdownList();
  },

  methods: {
    async preview() {
      if (this.isPending || (this.isApprover && this.isApproved)) {
        window.open("/?preview=1");
      } else {
        let productBanners = this.product_banners.map((product) => ({
          id: product.id,
          name: product.name ? product.name : "Product Banner",
          gallery_id: product.gallery_id
            ? product.gallery_id
            : product.image_id,
          entity_id: this.titleMenuOptions.find(
            (obj) => obj.name == product.entity_name
          )
            ? this.titleMenuOptions.find(
                (obj) => obj.name == product.entity_name
              ).id
            : null,
          url: product.url,
        }));

        let response = await postRequest(
          "/banners/products",
          {
            banners: productBanners,
            approval: 0,
            removeBanner: this.removedBannerIds,
          },
          true
        );

        if (response.data.success) {
          window.open("/?preview=1");
          location.reload();
        } else {
          this.$swal({
            icon: "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            window.open("/?preview=1");
          });
        }
      }
    },

    /**** gallery modal ****/

    openGalleryPBModal(index, modalName) {
      var heroBannerModal = document.getElementById(modalName);
      var galleryModal = document.getElementById("galleryModal");
      var index = (document.getElementById("slideIndex").value = index);
      document.getElementById("modal_id").value = modalName;

      heroBannerModal.classList.remove("show");
      heroBannerModal.style.display = "none";

      galleryModal.classList.add("show");
      galleryModal.style.display = "block";
    },

    handlePbAddImage(galleryId) {
      // Handle the added image ID here
      console.log("gallery : ", galleryId);

      this.product_banners[galleryId.index].image_url = galleryId.galleryUrl;

      // Store into banners array based on the slideIndex
      this.product_banners[galleryId.index].gallery_id = galleryId.galleryId;
    },

    /*** end of gallery modal function ***/

    openProductApproval(index, modalName) {
      document.getElementById("data_id").value = modalName;
    },

    addNewSlide() {
      // Check if both title and content are provided
      // Create a new accordion object
      const newSlide = {
        products_expanded: false,
        categories: "",
        image_url: require("@/assets/images/empty.jpg"),
        entity_id: 1,
        entity: 1,
        url: "",
      };

      // Add the new accordion to the accordions array
      this.product_banners.push(newSlide);
    },

    removeSlide(index_pb) {
      // Check if the index is valid
      if (index_pb >= 0 && index_pb < this.product_banners.length) {
        this.removedBannerIds.push(this.product_banners[index_pb].id);

        // Remove the element at the specified index from the banners array
        this.product_banners.splice(index_pb, 1);
      }
    },

    /****** function for auto complete ******/

    /** fetch the menu list*/
    async titleDropdownList() {
      let getEntity = await getRequest(`banners/home/categories/3/lists`, true);
      this.titleMenuOptions = getEntity.data.data;
    },

    /** get the dropdown list from the auto complete*/
    // searchPbOptions({ query }, index) {
    //   this.filteredEntities = this.titleMenuOptions
    //     .filter((option) =>
    //       option.name.toLowerCase().includes(query.toLowerCase())
    //     )
    //     .map((option) => option.name);
    // },

    /******* save product banner ********/

    async saveProductBanner(type) {
      let productBanners = this.product_banners.map((product) => ({
        id: product.id,
        name: product.name ? product.name : "Product Banner",
        gallery_id: product.gallery_id ? product.gallery_id : product.image_id,
        entity_id: this.titleMenuOptions.find(
          (obj) => obj.name == product.entity_name
        )
          ? this.titleMenuOptions.find((obj) => obj.name == product.entity_name)
              .id
          : null,
        url: product.url,
      }));

      let response = await postRequest(
        "/banners/products",
        {
          banners: productBanners,
          approval: type,
          removeBanner: this.removedBannerIds,
        },
        true
      );

      if (response.data.success) {
        this.$swal({
          icon: response.data.success ? "success" : "error",
          text: response.data.message,
          confirmButtonText: "Close",
        }).then(function () {
          window.location.reload();
        });
      }
    },
  },
};
</script>

<style scoped>
input[type="file"]::file-selector-button {
  border: none;
  background: lightgray;
  padding: 10px 20px;
  border-radius: 10px;
  color: black;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}

input[type="file"]::file-selector-button:hover {
  background: lightgray;
  color: black;
}

.banner-item {
  width: 100%;
}

.newSlideBtn {
  width: 94% !important;
}

.p-autocomplete {
  width: 100%;
}

.p-inputtext {
  width: "-webkit-fill-available";
}
</style>